import { listConversations } from './listConversations'
import { listUsers } from './listUsers'

export const ChatAPI = {
  listConversations,
  listUsers,
}
